<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import InductionAPI from "@/services/standards/inductionProgram/inductionProgramAPI";
import interventionActAPI from "@/services/standards/interventionAct/interventionActAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
          active: true,
        },
      ],
      list: [],
      themes: [],
      interventionActs: [],
      search: null,
      lastId: 1,
      deleteCount: 0,
      program: {
        induction_date: null,
        induction_final_date: null,
        induction_theme: null,
        evidence: null,
        observations: null,
      },

      trainingList: [],
      submitted: false,
      company: null,
      companyNit: this.$store.getters["company/getCompany"].nit,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      file: null,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      form_submitting: false,

    };
  },
  validations: {
    program: {
      induction_date: {
        required,
      },
      induction_theme: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(id = 10) {
      CompanyItemsAPI.getStatus(this.companyID, id)
        .then((response) => {
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getLastId() {
      InductionAPI.getAll(this.companyID, 1)
        .then((resp) => {
          if (resp.data.data && resp.data.data[0] && resp.data.data[0]['id']) {
            this.lastId = resp.data.data[0]['id'] + 1;
          }

          if (Array.isArray(resp.data.data)) {
            this.deleteCount = resp.data.data.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.companyNit}/1.2.2/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.companyNit}/1.2.2/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.program.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Hay campos requeridos sin diligenciar!",
          icon: "warning",
          typ: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      } else {
        this.loading1 = true,
          this.form_submitting = true;
        const res = await this.uploadDocument();
        if (res) {
          const data = {
            induction_date: this.program.induction_date,
            induction_theme: this.program.induction_theme,
            induction_final_date: this.program.induction_final_date,
            companies_id: this.companyID,
            evidence: this.program.evidence,
            observations: this.program.observations,
          };
          InductionAPI.save(data)
            .then((response) => {
              this.sendNotification(10, 10, true);
              const itemChange = {
                companies_id: this.companyID,
                item_id: 10,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading1 = false,
                    setTimeout(() => {
                      Swal.fire({
                        title: "¡Éxito!",
                        text: "¡Se ha registrado con éxito!",
                        icon: "success",
                        type: "success",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                    }, 2000);
                  window.location.reload();
                })
                .catch((error) => {
                  this.loading1 = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error");
        }
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 10)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/Formato/1.2.2-Lista-de-asistencia.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async printActa() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/ACTA_INTERVENCION_EMPRESA.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async printEvaluacion() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/EVALUACION_ASISTENCIA_INDUCCION_REINDUCCION.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    deleteInduccion(id) {
      InductionAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 10,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "Se ha sido eliminado con exito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTrainingPrograms() {
      InductionAPI.getTema(this.companyID)
        .then((response) => {
          this.loading = false;
          this.trainingList = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    // ── Actas de Intervención (1.2.2) ──
    getInterventionActs() {
      interventionActAPI.getAll(this.companyID)
        .then((r) => {
          this.interventionActs = (r && r.data && r.data.data) || [];
        })
        .catch((error) => console.log(error));
    },

    newIntervention() {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/acta-intervencion` });
    },

    editIntervention(id) {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/acta-intervencion/${id}` });
    },

    downloadIntervention(id) {
      window.open(interventionActAPI.pdfUrl(id), "_blank");
    },

    deleteIntervention(id) {
      interventionActAPI.delete(id)
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "Acta eliminada.", icon: "success", timer: 1500, showConfirmButton: false });
          this.getInterventionActs();
        })
        .catch((error) => { console.log(error); Swal.fire("Error", "No se pudo eliminar", "error"); });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 10,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },
  },

  mounted() {
    this.getLastId();
    this.getData();
    this.getItems();
    this.getItemData();
    this.getTrainingPrograms();
    this.getInterventionActs();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      Se subirán el registro de asistencia y la evaluación de
                      cada una de las capacitaciones planificadas en el item
                      1.2.1 "Programa Capacitación promoción y prevención".
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right m-b-0 d-flex justify-content-end flex-wrap">
                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1 my-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Asistencia a Capacitación
                  </button>
                  <button :disabled="!allowAccess()" @click="printActa" class="btn btn-primary mx-1 my-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Acta de Intervención en la Empresa
                  </button>
                  <button :disabled="!allowAccess()" @click="printEvaluacion" class="btn btn-primary mx-1 my-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Evaluación y Asistencia de Inducción y Reinducción
                  </button>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Tema de capacitación" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="program.induction_theme" :class="{
                        'is-invalid':
                          $v.program.induction_theme.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in trainingList" :key="index"
                        :value="item.training_done">
                        {{ item.training_done }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Evidencia de capacitación" label-for="file">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar" :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..."
                      v-model="file" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Fecha inicio de capacitación" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="program.induction_date" :class="{
                        'is-invalid':
                          $v.program.induction_date.$error && submitted,
                      }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.induction_date.$error">
                      <small v-if="!$v.program.induction_date.required" class="text-danger">
                        <b>La fecha de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha fin de capacitación" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="program.induction_final_date" :class="{
                        'is-invalid':
                          $v.program.induction_date.$error && submitted,
                      }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.induction_date.$error">
                      <small v-if="!$v.program.induction_date.required" class="text-danger">
                        <b>La fecha de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="program.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="!allowAccess() || !getRole('Crear') || this.form_submitting === true" type="submit"
                    class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr />

              <div class="table-responsive">
                <table
                  class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                  <thead class="table-active">
                    <tr>
                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                        Fecha inicio de capacitación
                      </th>

                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                        Fecha fin de Capacitación
                      </th>

                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
                        Nombre de la Capacitación
                      </th>
                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-8">
                        Observaciones
                      </th>
                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                        Evidencia
                      </th>
                      <th scope="col"
                        class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in themes" :key="item.id">
                      <td class="px-6 text-sm text-gray-500 mx-2">
                        {{ dateConvert(item.induction_date) }}
                      </td>

                      <td class="px-6 text-sm text-gray-500 mx-2">
                        {{ dateConvert(item.induction_final_date) }}
                      </td>

                      <td class="px-6 text-sm text-gray-500 mx-2">
                        <b>
                          Tema:
                          {{ item.induction_theme }}
                        </b>
                      </td>
                      <td class="px-6 text-sm text-gray-500 mx-2">
                        {{ item.observations }}
                      </td>

                      <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                        <button :disabled="!allowAccess()" style="
                            background-color: transparent !important;
                            border: none;
                          " type="button" @click="gotoDigitalOcean(`${item.evidence}`)">
                          <i class="mdi mdi-cloud-download"></i>
                        </button>
                      </td>
                      <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                        <div class="col-sm-12">
                          <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')">
                            <template v-slot:button-content>
                              <i class="mdi mdi-eye"></i>
                            </template>
                            <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                              v-b-modal="`modal${item.id}`">
                              Editar
                            </b-dropdown-item>
                            <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                              <div class="text-justify">
                                <h4 class="mt-2 text-primary text-center">
                                  Advertencia
                                </h4>
                                <p class="mt-3">
                                  Al modificar esta información se quitará el
                                  puntaje correspondiente a este ítem y será
                                  necesario realizar nuevamente la validación
                                  por parte del usuario responsable de Emisión.
                                </p>
                                <button type="button" @click="
                                  goPage(
                                    `/forms/estandares/${companyID}/induccion/${item.id}`
                                  )
                                  " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                  :disabled="!allowAccess()">
                                  Continuar
                                </button>
                                <button type="button" @click="$bvModal.hide(`modal${item.id}`)"
                                  class="btn btn-danger btn mx-2" data-dismiss="modal">
                                  Cancelar
                                </button>
                              </div>
                            </b-modal>
                            <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" :to="{
                              path: `/forms/estandares/${companyID}/induccion-ver/${item.id}`,
                            }">
                              Ver
                            </b-dropdown-item>
                            <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                              v-on:click="deleteInduccion(item.id)">Eliminar</b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Pagination ref="paginator" @loading="(load) => (loading = load)" :search="search"
                  @fetch="(items) => (themes = items)" />
              </div>

              <!-- ── Actas de Intervención de Empresa (branded + firma del encargado) ── -->
              <hr />
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">Actas de Intervención de Empresa</h5>
                <button :disabled="!allowAccess() || !getRole('Crear')" @click="newIntervention"
                  class="btn btn-primary btn-sm">
                  <i class="bx bx-plus"></i> Nueva acta de intervención
                </button>
              </div>
              <div class="table-responsive">
                <table
                  class="pt-2 table table-sm border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                  <thead class="table-active">
                    <tr>
                      <th class="px-6 text-left text-xs font-medium text-gray-500 align-middle">Fecha</th>
                      <th class="px-6 text-left text-xs font-medium text-gray-500 align-middle">Registro N°</th>
                      <th class="px-6 text-left text-xs font-medium text-gray-500 align-middle">Ciudad</th>
                      <th class="px-6 text-left text-xs font-medium text-gray-500 align-middle">Estado</th>
                      <th class="px-6 text-center text-xs font-medium text-gray-500 align-middle">Acta</th>
                      <th class="px-6 text-center text-xs font-medium text-gray-500 align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-if="interventionActs.length === 0">
                      <td colspan="6" class="text-center text-muted small py-3">Aún no hay actas de intervención registradas.</td>
                    </tr>
                    <tr v-for="acta in interventionActs" :key="acta.id">
                      <td class="px-6 text-sm text-gray-500">{{ dateConvert(acta.intervention_date) }}</td>
                      <td class="px-6 text-sm text-gray-500">{{ acta.registro_no || "-" }}</td>
                      <td class="px-6 text-sm text-gray-500">{{ acta.ciudad || "-" }}</td>
                      <td class="px-6 text-sm text-gray-500">
                        <span class="badge badge-pill px-2 py-1"
                          :class="acta.workflow_status === 'signed' ? 'badge-success' : 'badge-warning text-dark'">
                          {{ acta.workflow_status === 'signed' ? 'Firmada' : 'Borrador' }}
                        </span>
                      </td>
                      <td class="px-6 text-center align-middle">
                        <button type="button" class="btn btn-outline-primary btn-sm" title="Descargar acta"
                          @click="downloadIntervention(acta.id)">
                          <i class="bx bx-download"></i>
                        </button>
                      </td>
                      <td class="px-6 text-center align-middle">
                        <b-dropdown variant="primary" size="sm" dropleft>
                          <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                          <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                            @click="editIntervention(acta.id)">
                            {{ acta.workflow_status === 'signed' ? 'Ver' : 'Editar' }}
                          </b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess() || acta.workflow_status === 'signed'"
                            @click="deleteIntervention(acta.id)">
                            Eliminar
                          </b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
